<template>
  <div class="title bg-success mb-3">Problema <span v-if="this.problem.status === ProblemStatus.RESOLVED"> - Finalizado </span></div>
  <div class="row g-2">
     <div class="col-md-1">
      <label class="form-label">Ticket</label>
      <input disabled type="text" v-model="problem.ticketId" class="form-control">
    </div>
    <div class="col-md-6">
      <label class="form-label">Título</label>
      <input disabled type="text" v-model="problem.ticketTitle" class="form-control">
    </div>
    <div class="col-md-4">
      <label class="form-label">Horário</label>
      <input disabled type="text" v-model="readableTime" class="form-control">
    </div>
  </div>

  <br></br>
  <div class="row g-2">
    <div v-if="problem.host" class="col-md-4">
        <label class="form-label">Host</label>
        <input disabled ="text" v-model="problem.host" class="form-control">
    </div>
  <div v-if="problem.trigger" class="col-md-8">
    <label class="form-label">Trigger</label>
    <input disabled type="text" v-model="problem.trigger" class="form-control">
  </div>
</div>
<div class="row g-2">

  
</div>

<br></br>
<div class="title subtitle mt-3">Comentários</div>
<div class="d-flex gap-3 mt-3">
  <div class="d-flex flex-wrap gap-3 align-items-end">
    <div class="w-100">
      <label>Acompanhamento</label>
      <input type="datetime-local" class="form-control" v-model="ticketComment.fallowupDateTime" />
    </div>

    <div class="flex-grow-1">
      <label for="ticket-file">Anexar Arquivo:</label>
      <input id="ticket-file" type="file" multiple class="form-control"  @change="handleFileUpload" />
    </div>
  </div>

  <div class="w-75">
    <label for="ticket-text">Comentário:</label>
    <textarea id="ticket-text" class="form-control" rows="5" v-model="ticketComment.response" placeholder="Digite seu comentário..."></textarea>
  </div>

  <div v-if="filesInfos.length" class="mt-2">
    <small>{{ filesInfos.length }} arquivo(s) selecionado(s)</small>
  </div>
</div>

    <div v-if="filesInfos.length" class="mt-2">

    <div class="d-flex gap-3">
  <div v-for="(file, index) in filesInfos" :key="index">
    <div v-if="file.preview && file.type.startsWith('image/')" class="mt-1">
      <img :src="file.preview" alt="Preview" style="max-width: 100px; max-height: 100px;" />
    </div>
  </div>
  </div>
  <div v-for="(file, index) in filesInfos" :key="index">
      {{ file.name }}</div>
</div>

<div class="mb-3 d-flex gap-1">
  <button class="btn btn-primary mt-3"  :disabled="this.problem.status === ProblemStatus.RESOLVED" @click="addComment()"> Adicionar</button>

  <button class="btn btn-danger mt-3" :disabled="this.problem.status === ProblemStatus.RESOLVED"  @click="this.problem?.zabbix?.company?.id == [COMPANY_ID_MAP.DINAMICA] ? problem.isFinishing = true: finishProblem();">
    Finalizar
  </button>

  <ModalContent :is-modal-open="this.problem.isFinishing"
      @close="() => this.problem.isFinishing = false" 
        @send="() => {
          finishProblem();
        this.problem.isFinishing = false
      }" :title="`RBX Dinânica`">
    <component :is="closeCompanyComponentMap[this.problem.zabbix.company.id]" v-model="this.problem.closeData"></component>
  </ModalContent>
  
</div>
<div v-for="comment in problem.ticketMessages" :key="comment.id" class="mb-3">
  <div class="card shadow-sm border-0 simple-card">
    <div class="card-body p-3">
      <div class="fw-bold text-success mb-1">
        <i class="bi bi-person-circle me-1"></i>{{ comment.createdBy.name }}
      </div>
      <div class="text-secondary mb-1">
        <i class="bi bi-clock me-1"></i>{{ formatDate(comment.createdAt) }}
      </div>
      <div class="mb-2">
        <p class="card-text mb-0 bg-white rounded p-3 shadow-sm border" style="white-space: pre-line;">
          {{ comment.message }}
        </p>
      </div>
      <div v-if="comment.uploadedFiles && comment.uploadedFiles.length" class="mt-2">
        <strong>Anexos:</strong>
        <ul class="list-unstyled ms-2">
          <li v-for="file in comment.uploadedFiles" :key="file.id">
            <a href="#" @click.prevent="openFile(file)" class="link-primary text-decoration-underline">
              <i class="bi bi-paperclip me-1"></i>{{ file.originalName }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import { messageTicket, problemService, ticketMessageService, fileService, TicketCompanyService, closeTicket } from '@/services/backend/ApiService';
import { ZabbixApiService } from '@/services/backend/zabbixApiService';
import useEditMode from '@/services/EditingService';
import { convertTime } from '@/services/utils';
import dayjs from 'dayjs';
import { COMPANY_ID_MAP } from '../../../../zabbix-shared/enums/companyId';
import DinamicaRBXForm from './FormComponents/DinamicaRBXForm.vue';
import ModalContent from '@/components/ModalContent.vue';
import { ProblemStatus } from '../../../../zabbix-shared/interfaces/intefaces';


export default {
  components: {
    ModalContent
  },
  props:{
    problemId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      problem: {},
      ticketComment: { response: "", fallowup: {}, fallowupDateTime: '' },
      filesInfos: [],
      rawFiles: [],
      closeCompanyComponentMap: {
        [COMPANY_ID_MAP.DINAMICA]: DinamicaRBXForm
      },
      COMPANY_ID_MAP: COMPANY_ID_MAP,
      ProblemStatus
    };
  },
  setup() {
    const isEditing = useEditMode();

    return { isEditing };
  },
  async mounted() {
    this.problem = await problemService.findOne(this.$route.params.id ?? this.problemId);
    this.problem.ticketMessages.sort((a, b) => b.id - a.id );
    let {id} = this.problem.zabbix.company;

    if(!this.problem.triggerId && this.problem.itemId && this.problem.hostId){
        const [hostData, itemData, triggerData] = await Promise.all([
        ZabbixApiService.getHostById(id, this.problem.hostId),
        ZabbixApiService.getItemById(id, this.problem.itemId),
        ZabbixApiService.getTriggerById(id, this.problem.triggerId)
      ])

      this.problem.host = hostData?.host;
      this.problem.item = itemData?.name;
      this.problem.trigger = triggerData?.description;

    };

    const now = new Date();
    now.setMinutes(now.getMinutes() + 10);
    const pad = n => n.toString().padStart(2, '0');
    const localISOTime = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}`;

    this.ticketComment = {
      zabbixId:  this.problem.zabbix.id,
      problemId: this.problem.id,
      ticket_id: this.problem.ticketId,
      fallowup: { days: 0, hours: 0, minutes: 30},
      fallowupDateTime: localISOTime,
      response: "",
    }
  },
  methods:{
  async addComment(){
    if (!this.ticketComment.response.trim() && !this.rawFiles.length) {
      alert('Digite uma mensagem ou anexe pelo menos um arquivo.');
      return;
    }
    const company = {
      id: this.problem.zabbix.company.id
    }

    const ticketMessage = {
      company,
      problem: {
        id: this.problem.id
      },
      message: this.ticketComment.response
    }
    
    const createdMessage = await ticketMessageService.create(ticketMessage);
    
    if(this.problem.triggerId){
      await TicketCompanyService.addMessage( {...this.problem, message: this.ticketComment.response});
    }

    const uploadFile = {
      company,
      rawFiles: this.rawFiles,
      ticketMessageId: createdMessage.id
    }

    if (this.rawFiles.length) {
      await fileService.create(uploadFile);
      this.problem = await problemService.findOne(this.problem.id);
      this.problem.ticketMessages.sort((a, b) => b.id - a.id );
    } else {
      this.problem.ticketMessages.unshift(createdMessage);
    }

    let futureDate = null;
    if (this.ticketComment.fallowupDateTime) {
      futureDate = new Date(this.ticketComment.fallowupDateTime);
    }

    const problemEntity = {
      fallowupTime: futureDate
    }
    
    await problemService.update(this.problem.id, problemEntity)
    await messageTicket(this.ticketComment);
    if(this.problem.triggerId){
      await ZabbixApiService.addMessageToProblem(this.problem.eventid, this.ticketComment.response, this.problem.zabbix.id, this.problem.zabbix.company.id);
      this.problem.ticketMessages.unshift(message);
    }
   },
   async finishProblem() {
      this.problem.status = "resolved";
      this.problem.company = { id: this.problem.zabbix.company.id };
      try{
        await closeTicket({
          ticket_id: this.problem.ticketId,
          resolution: this.ticketComment.response,
          zabbixId: this.problem.zabbix.id
        });
      } catch(error){}

      if(this.problem.triggerId){
         await TicketCompanyService.close( {...this.problem, message: this.ticketComment.response, ...this.problem.closeData});
      }
     
      await problemService.update(this.problem.id, this.problem);
      
      const company = {
        id: this.problem.zabbix.company.id
      }

      const ticketMessage = {
        company,
        problem: {
          id: this.problem.id
        },
        message: this.ticketComment.response
      }
    
      const createdMessage = await ticketMessageService.create(ticketMessage);
      this.problem.ticketMessages.unshift(createdMessage);
      this.problems = this.problems.filter((value) => value.problemId != problem.problemId)
    },
    formatDate(dateStr) {
      return dayjs(dateStr).format('DD/MM/YYYY HH:mm')
    },
    handleFileUpload(event) {
      const files = Array.from(event.target.files);
      this.rawFiles = files;
      this.filesInfos = [];

      files.forEach(file => {
        const reader = new FileReader();
        reader.onload = e => {
          this.filesInfos.push({
            name: file.name,
            type: file.type,
            preview: e.target.result,
          });
        };
        if (file.type.startsWith('image/')) {
          reader.readAsDataURL(file);
        } else {
          this.filesInfos.push({
            name: file.name,
            type: file.type,
            preview: null,
          });
        }
      });
  },
  async openFile(file) {
      const blob = await fileService.findOne(file.id);
      const url = URL.createObjectURL(blob);
  
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
     
    },
  },
  computed: {
    readableTime(){
      return convertTime(this.problem.clock)
    }
  }
}
</script>

<style scoped>
.simple-card {
  background: #e6f6f6;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(31, 38, 135, 0.08);
}
</style>
